import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import './TabDashboard.scss';

function TabDashboard({ title, route, onRedirect }) {
  return (
    <button type="button" className="tab-dashboard" onClick={() => onRedirect(route)}>
      <Typography
        sx={{ fontSize: 18, color: 'rgba(255, 255, 255, 0.85)', fontWeight: 700 }}
        color="text.secondary">
        {title}
      </Typography>
    </button>
  );
}

TabDashboard.propTypes = {
  title: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  onRedirect: PropTypes.func.isRequired,
};

export default TabDashboard;
